module.exports = __webpack_public_path__ + "img/anhui_unicom_bsp.a52e0bd6.png";